CoreDialogController = App.loadClass 'core::Angular/DialogController'

class exports.DialogController extends CoreDialogController

    constructor: (@scope, @transitions, @state, @mups, @modalInstance, @window, @transition$) ->
        super @scope, @transitions, @modalInstance
        options = JSON.parse(@transition$.params().options)

        if options.file_type?.extension
            @mups.setFileExtension(options.file_type.extension)

        # Instance Data
        @scope.msg = {}
        @scope.uploader = null
        @mups.options = options
        @scope.options = options
        @scope.$parent.title = 'Upload'
        @scope.disable_upload = true
        @scope.ui = {}
        @scope.ui.waiting_on_uploads = false
        @loadFormatHelp()
        @mups.clearUpload()

        if @scope.options.type.name is 'Management Zone' or @mups.getFileExtension() is null
            @scope.file_ext = 'shp,shx,dbf,zip'
            @scope.options.file_type =
                id: null
                extension: '.shp, .shx, .dbf'
        else
            @scope.file_ext = @mups.getFileExtension()

        # Function Declarations
        @scope.finish = @finish
        @scope.finishedUploading = @finishedUploading
        @scope.processUploads = @processUploads
        @scope.process = @process
        @window.inputFileUploading = @inputFileUploading

        # Listeners
        @scope.$watch 'uploader', () =>
            @scope.uploader?.bind 'FilesRemoved', (uploader, file) =>
                if uploader.files.length is 0
                    @scope.validFiles = false
                    @scope.disable_upload = true
                @mups.deleteTempFile file
            @mups.uploader = @scope.uploader

        @scope.$on 'uploads:clear_message', () =>
            @scope.msg = {}

        @scope.$on 'uploads:files_removed', () =>
            # process uploads
            @process() if @scope.uploader.files?.length

    inputFileUploading: () =>
        @scope.ui.waiting_on_uploads = true
        @scope.$apply()

    finishedUploading: () =>
        @scope.ui.waiting_on_uploads = false
        @scope.disable_upload = false

    process: () =>
        # show a message that describes points in the process
        @setAlert 'info', 'Checking for duplicate files...'
        @mups.existingFiles().then (response) =>
            @scope.duplicates = response.data.data

            if @scope.duplicates.length
                @setAlert 'warning', 'Found duplicate files. Delete or replace duplicate files before continuing.'
                @mups.showDuplicateFileDialog(@scope.duplicates)
            else
                @processUploads()
                @setAlert 'info', 'Uploading files...'

    processUploads: () =>
        # disable the button to prevent duplicate requests
        @scope.disable_upload = true

        # set parameters for finalizing upload
        params =
            csq_id: @mups.csq_id ? null
            upload_type: @scope.options.type.name
            format_type: @scope.options.format ? null
            extension: @scope.file_ext

        @mups.processUploads(params).then (response) =>
            if response.data.status.type is 'success'
                # Notify the user if we found invalid shapefiles
                if response.data.data.invalid_files?.length
                    @mups.queueRemoval response.data.data.invalid_files
                    @mups.showInvalidShapefileDialog response.data.data.invalid_files

                # Finish processing if there were valid files
                if response.data.data.files?.length
                    @setAlert 'success', 'Files uploaded successfully'
                    @mups.csq_id = response.data.data.csq_id
                    @mups.file_list = response.data.data.files
                    @mups.validFiles = true
                    # @scope.disable_upload = false
                # finish the process
                @finish()

            else if response.data.status.type is 'error'
                @setAlert 'error', response.data.status.msg
                # enable the button since we failed processing
                @scope.disable_upload = false

    finish: () =>
        @modalInstance.close()
        @mups.finalizeUpload().then (res) =>
            undefined


    # If the upload dialog is closed we have some cleanup to do
    cancel: () =>
        # Remove the uneeded directory/files and unset csq_id reference
        @mups.deleteCsqDirectory()
        # Unset our reference to the pluploader so we can instantiate a new one
        @scope.uploader = null
        @modalInstance.close()


    setAlert: (type, text) =>
        @scope.msg.type = "alert-#{type}"
        @scope.msg.text = text


    loadFormatHelp: () =>
        opts = @scope.options.file_type
        if not opts?.name?
            @scope.options.format = 'Shapefile'
            @scope.options.format_text = 'This is a multi-file format. You may upload the
                individual SHX, SHP, and DBF files that make up a set, or a zip containing
                one or more file sets.'
        else
            @scope.options.format = @mups.extractFormat(opts.name)
            @loadScopeData(@mups.getFormatDescription(opts.id), 'text').then (response) =>
                @scope.options.format_text = @scope.text
